import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallReturned({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={8} cy={8} r={8} fill="#475E9F" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.23 8.53L5.4 10.8c.14.1.28.19.46.19.37 0 .7-.33.7-.7 0-.19-.1-.37-.23-.51l-1-1.07H8.8a.7.7 0 00.7-.7.7.7 0 00-.7-.69H5.32l1-1.1a.75.75 0 00.23-.51c0-.37-.33-.7-.7-.7a.6.6 0 00-.46.19L3.23 7.5a.75.75 0 00-.23.52c0 .18.1.37.23.5z"
        fill="#fff"
      />
      <path
        opacity={0.6}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.36 3.8a.7.7 0 01.93-.35 5 5 0 010 9.1.7.7 0 11-.58-1.27 3.6 3.6 0 000-6.55.7.7 0 01-.35-.93z"
        fill="#fff"
      />
    </svg>
  );
}

SvgTickSmallReturned.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallReturned.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgTickSmallReturned svgRef={ref} {...props} />
));
export default ForwardRef;
